import { cn } from "@gymflow/helpers";
import { motion } from "framer-motion";

export function ToggleModeButtonNew<T>({
  className,
  value,
  onChange,
  options,
}: {
  className?: string;
  options: [
    {
      label: string;
      value: T;
    },
    {
      label: string;
      value: T;
    },
  ];
  value: T;
  onChange: (v: T) => void;
}) {
  return (
    <motion.div
      className={cn(
        "relative flex h-11 cursor-pointer items-center rounded-[10px] border border-gray-200 bg-gray-50 shadow-sm",
        className,
      )}
      onClick={() => {
        onChange(
          value === options[0].value ? options[1].value : options[0].value,
        );
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onChange(
            value === options[0].value ? options[1].value : options[0].value,
          );
        }
      }}
    >
      <motion.div
        className={cn(
          "absolute bottom-1 top-1 flex w-[calc(50%-0.5rem)] rounded-lg shadow-sm bg-gray-0",
        )}
        initial={false}
        animate={{
          x: value === options[0].value ? 4 : "calc(100% + 0.75rem)",
        }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 30,
        }}
      />
      <div className="z-10 flex w-full flex-row">
        <div className={cn("flex flex-1 items-center justify-center text-sm font-semibold transition-all",
          value === options[1].value && "text-gray-500"
        )}>
          {options[0].label}
        </div>
        <div className={cn("flex flex-1 items-center justify-center text-sm font-semibold transition-all",
          value === options[0].value && "text-gray-500"
        )}>
          {options[1].label}
        </div>
      </div>
    </motion.div>
  );
}
